module.exports = __webpack_public_path__ + "img/icon-edit-blue.daf21095.svg";